export function pluralizeWord(stem, singular, plural, count) {
  if (!stem) {
    return stem;
  }
  return stem.concat(count === 1 ? singular : plural);
}